export default __webpack_public_path__ + "static/media/p03 p02.b7e598ff.jpg";